// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7203":"3b2e8fc2c6bdfd0c","8518":"c9cbc34ed6145c5c","8977":"f2ebe06f2da89f78"}[chunkId] + ".css";
};